module.exports = __webpack_public_path__ + "img/eyejack-logo.bd3ea342.png";